export const WEEKS_PER_QUARTER = 13
